import { api } from '@/apis';
import { encodeParams } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useUser(username) {
  const queryKey = ['users', username];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const searchParams = encodeParams({
        query: {
          userId: {
            $regex: username,
            $options: 'i',
          },
        },
        projection: {
          _id: false,
          userId: true,
          forenames: true,
          surname: true,
          displayName: true,
        },
      });

      const users = await api.get('users', { searchParams, signal }).json();

      if (users.length === 0) {
        throw new Error(`User with username "${username}" not found.`);
      }

      return users[0];
    },
    enabled: !!username,
    staleTime: 1000 * 60 * 60,
  });

  return {
    ...query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
